import React from 'react';
import PropTypes from 'prop-types';
import Table from 'react-bootstrap/Table';
import AccountTag from '../lib/AccountTag';
import { decodeHex } from '../common/Helpers';

const TransactionAcceptedCredentials = (props) => {
  const { acceptedCredentials } = props;

  return (
    <div>
      <Table responsive condensed="true">
        <thead>
          <tr>
            <th colSpan="2">Accepted Credentials for Permissioned Domain</th>
          </tr>
        </thead>
        <tbody>
          { acceptedCredentials.map((acceptedCredential, index) =>
          <tr key={index}>
            <td>
              {acceptedCredential && acceptedCredential.Credential && acceptedCredential.Credential.Issuer &&
                <AccountTag link>{acceptedCredential.Credential.Issuer}</AccountTag>
              }
            </td>
            <td>
              {acceptedCredential && acceptedCredential.Credential && acceptedCredential.Credential.CredentialType && decodeHex(acceptedCredential.Credential.CredentialType)}
            </td>
          </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
}

TransactionAcceptedCredentials.propTypes = {
  acceptedCredentials: PropTypes.array.isRequired,
}

export default TransactionAcceptedCredentials;